document.addEventListener('alpine:init', () => {
    window.Alpine.data('progressBar', (config) => ({
        currentValue: 0,
        showProgressBar: true,
        init() {
            this.calculateProgress();
            window.addEventListener('scroll', (event) => {
                this.calculateProgress();
            });
        },
        calculateProgress() {
            let currentScrollPosition = window.scrollY;
            // get heights from navigations from css root variables
            let getMainNaviHeightDesktop = parseInt(getComputedStyle(document.body).getPropertyValue('--navbar-main-height'));
            let getTopNaviHeightDesktop = parseInt(getComputedStyle(document.body).getPropertyValue('--navbar-top-height'));
            let progressBarHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--progress-bar-height'));
            // check first if ad is even available
            let advertisingPromotion = document.querySelector('.advertising-promotion');
            let getAdHeight = advertisingPromotion ? advertisingPromotion.clientHeight : 0;
            // get height of everything else above the article itself to also substract it
            let scrollPositionWithoutTop = 0;
            let documentHeight = document.querySelector('.theme-blog').clientHeight;
            let footerHeight = document.querySelector('footer').clientHeight;
            let onePercent = ((document.querySelector('article').clientHeight) - window.innerHeight) / 100;

            if (window.innerWidth > 1024) {
                scrollPositionWithoutTop = currentScrollPosition - getMainNaviHeightDesktop - getTopNaviHeightDesktop - getAdHeight;
                documentHeight = documentHeight - getMainNaviHeightDesktop - getTopNaviHeightDesktop - getAdHeight;
            } else {
                scrollPositionWithoutTop = currentScrollPosition - getMainNaviHeightDesktop - getAdHeight;
                documentHeight = documentHeight - getMainNaviHeightDesktop - getAdHeight - progressBarHeight;
            }

            this.showProgressBar = window.scrollY <= (documentHeight - footerHeight);
            let progress = scrollPositionWithoutTop / onePercent;

            this.currentValue = progress > 100 ? 100 : progress;
        }
    }));
});
